<div  style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex">
        <div class="h6 font-weight-bold sm-22 pt-1">
            <!-- <i class="fas fa-redo pr-2 pl-0 primary-text"></i> -->
            <svg  class="mr-2 pt-1"  width="22" height="26" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 9.5V15.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M0.5 14.5H11.5C11.5 13.3954 10.6046 12.5 9.5 12.5H7C7 11.3954 6.10457 10.5 5 10.5H0.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 12.5H7" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 6.5C14.1569 6.5 15.5 5.15685 15.5 3.5C15.5 1.84315 14.1569 0.5 12.5 0.5C10.8431 0.5 9.5 1.84315 9.5 3.5C9.5 5.15685 10.8431 6.5 12.5 6.5Z" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.5 8.50003C12.5001 9.38977 11.9124 10.1726 11.058 10.4208C10.2036 10.6691 9.28796 10.323 8.81128 9.57177C8.33459 8.8205 8.41151 7.84467 9.00002 7.17737" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Referrals
        </div>
    </div>
    <div class="row m-0">
        <div class="col-md-6 head-top">
            <h5 class="sm-18 color-blue mb-4 gilroy-bold">Refer a friend</h5>
            <p class="sm-12 gilroy-med color-royalBlue col-10 col-md-8 m-0 p-0 mobile16">Share this link with your family and friends to get awesome rewards!</p>
            <div class="w-100 my-4 d-flex align-items-center">
                <input [(ngModel)]="referLink" type="text" autocomplete="off" class="input_field p-3 py-2 w-100 box-shadows overflowClass" readonly
                placeholder="Link here..." id="referLink">
                <i class="far fa-copy sm-18 primary-text ml-neg cursor-pointer" data-toggle="tooltip" title="Copy" (click)="copyMessage(referLink)"></i>
            </div>
            
            <p class="sm-12 gilroy-med color-royalBlue col-10 m-0 pl-3 mobile16">
                Or, invite someone directly with an invitation email. Enter their email address below
            </p>
            <form #referEmailForm="ngForm" (ngSubmit)="refer(referEmailForm)">
                <div class="w-100 my-4">
                    <input ngModel pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" type="email" name="email" autocomplete="off" class="input_field p-3 py-2 w-100 box-shadows" 
                    placeholder="Enter their email address" required>
                </div>
                <button [disabled]="!referEmailForm.valid" class="btn primary-btn text-light py-2 h-auto sm-12 gilroy-bold col-12 col-md-6">Send a referral email</button>
            </form>
        </div>
    </div>
</div>